import { type QuestionsProps } from "@/features/questionnaire/types";
import { getTranslation } from "@/features/questionnaire/utils";
import { RadioButtonGroup } from "@repo/skapa";
import { useSettings } from "@repo/ui";

export const SingleSelectQuestion = ({
  answer,
  onAnswerIdAnswered,
  question,
}: QuestionsProps) => {
  const { language } = useSettings();
  const selectedAnswerId = answer?.answerIds[0] || "";
  if (!question?.answers) {
    return null;
  }
  return (
    <RadioButtonGroup
      subtle
      list={question.answers.map((option) => {
        return {
          name: `${question.question_id_key}`,
          key: `${question.question_id_key}-${option.answer_id_key}`,
          id: `${question.question_id_key}-${option.answer_id_key}`,
          label: getTranslation(
            option.answer_translation ?? [],
            language,
            option.answer_name
          ),
          value: option.answer_id_key,
          checked: option.answer_id_key === selectedAnswerId,
          onChange: () => onAnswerIdAnswered?.([option.answer_id_key]),
        };
      })}
    />
  );
};
